import { CircularProgress, ListItemButton } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import Loader from 'src/components/loader/loader';

const ScrollToBottom = ({ onScrollToBottom, loading }) => {
    const bottomBoundaryRef = useRef(null);

    useEffect(() => {
        const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.8, // Trigger when 80% of the element is visible
        };

        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Call the provided function
                    onScrollToBottom();
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection, options);

        if (bottomBoundaryRef.current) {
            observer.observe(bottomBoundaryRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [onScrollToBottom]);

    return (
        <>
            <div ref={bottomBoundaryRef} />
            <ListItemButton
                sx={{
                    py: 1.5,
                    px: 2.5,
                    mt: '1px',
                }}
            >
                {/* <Loader loading={loading} /> */}
                {loading && (
                    <CircularProgress
                        size={24}
                        color="inherit"
                        sx={{
                            position: 'absolute', 
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px', 
                            marginLeft: '-12px', 
                        }}
                    />
                )}
            </ListItemButton>
        </>
    )
};

export default ScrollToBottom;
